<template>
  <div>
    <el-form-item label-position="horizontal">
      <el-row type="flex" align="middle" :gutter="20">
        <el-col :span="3">
          <el-checkbox 
            v-model="delayEnabled" 
            @change="onDelayToggle"
          >
            Delay
            <el-tooltip content="Add delay before calling this API">
              <i class="el-icon-question" />
            </el-tooltip>
          </el-checkbox>
        </el-col>
        
        <el-col v-if="delayEnabled" :span="17">
          <el-row type="flex" align="middle" :gutter="10">
            <el-col :span="showAdvanced?3:12">
              <el-slider
                v-model="delayDuration"
                v-if="!showAdvanced"
                :min="1"
                :max="6"
                :step="1"
                :show-stops="true"
                :show-tooltip="true"
                :format-tooltip="formatTooltip"
                @change="onDelayDurationChange"
              ></el-slider>
              <el-input-number
                v-else
                v-model="delayDuration"
                :step="1"
                :controls="false"
                style="width: 120px;"
                @change="onDelayDurationChange"
              ></el-input-number>
            </el-col>
            <el-col :span="6">
              <el-tag type="primary" size="mini">{{ delayDuration }}s</el-tag>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-form-item>
  </div>
</template>

<script>
/**
 * RequestSettings - Advanced API request configuration options.
 *
 * @component
 * @description Provides optional delay configuration before API execution. Features a checkbox to
 * enable delays with either a slider (default) or number input (advanced mode) for setting the
 * delay duration in seconds (1-6s for slider, unlimited for advanced).
 *
 * @prop {Object} settings - Settings configuration object (synced via .sync modifier)
 * @prop {boolean} [settings.delayEnabled] - Whether delay is enabled
 * @prop {number} [settings.delayDuration] - Delay duration in seconds
 *
 * @fires update:settings - Emitted when settings change
 *
 * @example
 * <RequestSettings
 *   :settings.sync="api.settings"
 * />
 */
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  props: ["settings"],
  computed: {
    ...mapGetters(["showAdvanced"]),
  },
  data() {
    return {
      delayEnabled: false,
      delayDuration: 1,
    };
  },
  mounted() {
    // Initialize from props if settings exist
    if (this.settings) {
      this.delayEnabled = this.settings.delayEnabled || false;
      this.delayDuration = this.settings.delayDuration || 1;
    }
  },
  methods: {
    formatTooltip(value) {
      return `${value} second${value !== 1 ? 's' : ''}`;
    },
    onDelayToggle(enabled) {
      this.emitSettings();
    },
    onDelayDurationChange(value) {
      this.emitSettings();
    },
    emitSettings() {
      const settings = {
        delayEnabled: this.delayEnabled,
        delayDuration: this.delayEnabled ? this.delayDuration : null,
      };
      this.$emit("update:settings", settings);
    },
  },
  watch: {
    settings: {
      handler(newSettings) {
        this.delayEnabled = false;
        this.delayDuration = 1;
        if (newSettings) {
          this.delayEnabled = newSettings.delayEnabled || false;
          this.delayDuration = newSettings.delayDuration || 1;
        }
      },
      deep: true,
    },
  },
};
</script>
